// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1BwZ-","col":"styles_col__3GKEG","fulfillmentStatus":"styles_fulfillmentStatus__1E_EY","emailCol":"styles_emailCol__2MFcp"};